module.exports = __webpack_public_path__ + "static/img/course-icon.e9e917de.svg";